import React from 'react';
import { FormGroup, ControlLabel } from 'react-bootstrap';
import PropTypes from 'prop-types';

import Tooltip from '../../../../../../../../components/Tooltip';

import * as types from '../../reducer/constants';

const FieldDenyLinksDuplicate = ({ form, dispatchServiceData }) => {
  const { deny_duplicates } = form;
  const selectedValue = deny_duplicates ? '1' : '0';

  const onChange = (e) => {
    const value = e.target.value === '1';
    dispatchServiceData({ type: types.EDIT_SERVICES_FORM_CHANGE_DENY_DUPLICATES, value })
  };

  return (
    <>
      <FormGroup>
        <ControlLabel htmlFor="deny_duplicates">
          Deny link duplicates
          {' '}
          <Tooltip
            placement="top"
            text={(
              <p>
                When you set
                <br />
                {' '}
                Deny link duplicates = Yes,
                <br />
                {' '}
                a user will not be able to
                <br />
                {' '}
                place a new order if there
                <br />
                {' '}
                has been another order within
                <br />
                {' '}
                90 days with the same Service ID
                <br />
                {' '}
                that contains the same link
                <br />
                {' '}
                and has the Awaiting, Pending,
                <br />
                {' '}
                In progress, Processing or Fail status
              </p>
            )}
            tooltipClass="tooltip__top"
          >
            <span className="fas fa-info-circle cursor-help" />
          </Tooltip>
        </ControlLabel>
        <select name="deny_duplicates" id="deny_duplicates" className="form-control" value={selectedValue} onChange={onChange}>
          <option value="1">Yes</option>
          <option value="0">No</option>
        </select>
      </FormGroup>
    </>
  );
};

FieldDenyLinksDuplicate.propTypes = {
  form: PropTypes.object,
  dispatchServiceData: PropTypes.func,
}

export default FieldDenyLinksDuplicate;
